import React from "react"
import {
  RadioRating,
  TextareaComment,
  FeedbackModal,
  FeedbackQuestion,
} from "../../components/Feedback"

const ReportFeedback = (props) => {
  return (
    <FeedbackModal {...props}>
      <FeedbackQuestion question="How would you rate your satisfaction with this report?">
        <RadioRating
          min={1}
          max={5}
          groupName="report-view-feedback-1"
          minScaleText={"Not Satisfied"}
          maxScaleText={"Very Satisfied"}
        />
      </FeedbackQuestion>
      <FeedbackQuestion question="Did you find the content easy to follow?">
        <RadioRating
          min={1}
          max={5}
          groupName="report-view-feedback-2"
          minScaleText={"Not Easy"}
          maxScaleText={"Very Easy"}
        />
      </FeedbackQuestion>
      <FeedbackQuestion question="How would you rate the information provided in this report?">
        <RadioRating
          min={1}
          max={5}
          groupName="report-view-feedback-3"
          minScaleText={"Poor"}
          maxScaleText={"Excellent"}
        />
      </FeedbackQuestion>
      <FeedbackQuestion question="Additional comments about this report (optional)">
        <TextareaComment name="report-view-feedback" />
      </FeedbackQuestion>
    </FeedbackModal>
  )
}

export default ReportFeedback
